import { splitPhoneNumber } from 'src/components/Form/FormGenerator/utils/splitPhoneNumber';

type ModifyFormDataProps = {
  data: Record<string, string>;
  hasCodeField: boolean;
};

export const modifyFormData = ({
  data,
  hasCodeField
}: ModifyFormDataProps): Record<string, string> => {
  if (!hasCodeField || (hasCodeField && data.dialingCode)) {
    return data;
  }

  const phoneParsed = splitPhoneNumber('+' + Number(data.phone.replace(/\s+/g, '')));
  return {
    ...data,
    dialingCode: phoneParsed.code || '',
    phone: phoneParsed.phone || ''
  };
};
